<div class="spinner-container">
  <img src="assets/images/preloader.gif" />
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
